// extracted by css-extract-rspack-plugin
export default {"propertyLabel":"doWROxdytlc9DOhn","property":"hQDj5Ox8Y8E0_OBg","propertyValue":"oqPuJhiP5Pwylb6S","opticallyCenteredProperty":"NW5rQ8bF28CWCmcZ"};